import React, { useState } from "react";
import { DynamicDropdown } from "src/Components";
import UsersDropdown from "src/Components/Dropdown/Users/UsersDropdown";
import { IAdaptationReportSearchParams } from "src/Interfaces/collateral";
import { getAdaptationReportTable } from "src/Requests/collateral";
import { getBaseInstruments } from "src/Requests/coveredCall";
import { getStepInstruments } from "src/Requests/stepRequests";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";

const AdaptationReport = () => {
  const [searchParams, setSearchParams] = useState(
    {} as IAdaptationReportSearchParams,
  );

  const changeHandler = (name: string, value: any) => {
    setSearchParams({ ...searchParams, [name]: value });
  };

  return (
    <div className="w-full flex flex-col justify-start items-start gap-5">
      <div className="flex flex-row justify-start items-start gap-3 mx-auto">
        <div className="w-64">
          <UsersDropdown
            label="اکانت"
            name="accountId"
            value={searchParams.accountId}
            onChange={changeHandler}
            extraLabel
          />
        </div>
        <div className="w-64">
          <DynamicDropdown
            dropdown={{
              name: "baseInstrumentId",
              placeholder: "نماد پایه",
              extraLabel: true,
            }}
            onChange={changeHandler}
            getData={() => getBaseInstruments()}
            value={searchParams.baseInstrumentId}
          />
        </div>
        <div className="w-64">
          <DynamicDropdown
            dropdown={{
              name: "instrumentId",
              placeholder: "نماد",
              extraLabel: true,
            }}
            onChange={changeHandler}
            getData={getStepInstruments}
            value={searchParams.intrumentId}
          />
        </div>
      </div>

      <TableTemplate
        TableUI={({ reports, onAction, sortingType, setSortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
          />
        )}
        getDataTable={getAdaptationReportTable}
        searchParameters={searchParams}
        refreshTableTime={5000}
        withSort
      />
    </div>
  );
};

export default AdaptationReport;
